var pattern_list = [
  // solid fill
  { id: 'solid', transform: '', pattern: '' },

  {
    id: 'stripes-s1-45',
    transform: 'rotate(45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="10" />',
  },
  {
    id: 'stripes-s2-45',
    transform: 'rotate(45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="20" />',
  },
  {
    id: 'stripes-s3-45',
    transform: 'rotate(45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="30" />',
  },
  {
    id: 'stripes-s4-45',
    transform: 'rotate(45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="40" />',
  },

  {
    id: 'stripes-s1-315',
    transform: 'rotate(-45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="10" />',
  },
  {
    id: 'stripes-s2-315',
    transform: 'rotate(-45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="20" />',
  },
  {
    id: 'stripes-s3-315',
    transform: 'rotate(-45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="30" />',
  },
  {
    id: 'stripes-s4-315',
    transform: 'rotate(-45)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="40" />',
  },

  {
    id: 'stripes-s1',
    transform: '',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="10" />',
  },
  {
    id: 'stripes-s2',
    transform: '',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="20" />',
  },
  {
    id: 'stripes-s3',
    transform: '',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="30" />',
  },
  {
    id: 'stripes-s4',
    transform: '',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="40" />',
  },
  {
    id: 'dotted-s1',
    transform: 'scale(0.3)',
    pattern: ' <circle cx="10" cy="10" r="8" fill="black" />',
  },
  {
    id: 'dotted-s2',
    transform: 'scale(0.45)',
    pattern: ' <circle cx="10" cy="10" r="10" fill="black" />',
  },
  {
    id: 'dotted-s3',
    transform: 'scale(0.6)',
    pattern: ' <circle cx="10" cy="10" r="10" fill="black" />',
  },
  {
    id: 'dotted-s4',
    transform: 'scale(0.8)',
    pattern: ' <circle cx="10" cy="10" r="10" fill="black" />',
  },
  {
    id: 'checker-s1',
    transform: 'translate(4 4) scale(0.3 0.3)',
    pattern: ' <rect x="0" y="0" width="15" height="15" fill="black" />',
  },
  {
    id: 'checker-s2',
    transform: 'translate(3 3) scale(0.5 0.5)',
    pattern: ' <rect x="0" y="0" width="17" height="17" fill="black" />',
  },

  {
    id: 'checker-s3',
    transform: 'translate(3 3) scale(0.7 0.7)',
    pattern: ' <rect x="0" y="0" width="18" height="18" fill="black" />',
  },
  {
    id: 'checker-s4',
    transform: 'translate(2 2) scale(0.85 0.85)',
    pattern: ' <rect x="0" y="0" width="19" height="19" fill="black" />',
  },
  {
    id: 'checker-s1-45',
    transform: 'rotate(45) scale(0.3 0.3)',
    pattern: ' <rect x="0" y="0" width="15" height="15" fill="black" />',
  },
  {
    id: 'checker-s2-45',
    transform: 'rotate(45) scale(0.5 0.5)',
    pattern: ' <rect x="0" y="0" width="17" height="17" fill="black" />',
  },
  {
    id: 'checker-s3-45',
    transform: 'rotate(45) scale(0.7 0.7)',
    pattern: ' <rect x="0" y="0" width="18" height="18" fill="black" />',
  },
  {
    id: 'checker-s4-45',
    transform: 'rotate(45) scale(0.85 0.85)',
    pattern: ' <rect x="0" y="0" width="19" height="19" fill="black" />',
  },
  {
    id: 'triangle-s1',
    transform: 'scale(0.4)',
    pattern:
      '<polygon points="0,18 18,18 9,0" style="fill:black;stroke:black;" />',
  },
  {
    id: 'triangle-s2',
    transform: 'translate(2 2) scale(0.5)',
    pattern:
      '<polygon points="0,18 18,18 9,0" style="fill:black;stroke:black;" />',
  },
  {
    id: 'triangle-s3',
    transform: 'translate(3 3) scale(0.6)',
    pattern:
      '<polygon points="0,20 20,20 10,0" style="fill:black;stroke:black;" />',
  },
  {
    id: 'triangle-s4',
    transform: 'translate(4 4) scale(0.7)',
    pattern:
      '<polygon points="0,22 22,22 11,0" style="fill:black;stroke:black;" />',
  },
  {
    id: 'crosshatch-s1',
    transform: 'scale(0.2)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s2',
    transform: 'scale(0.3)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s3',
    transform: 'scale(0.4)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s4',
    transform: 'scale(0.5)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s1-45',
    transform: 'rotate(45) scale(0.2)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s2-45',
    transform: 'rotate(45) scale(0.3)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s3-45',
    transform: 'rotate(45) scale(0.4)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
  {
    id: 'crosshatch-s4-45',
    transform: 'rotate(45) scale(0.5)',
    pattern:
      '<line x1="0" y="0" x2="0" y2="50" stroke="black" stroke-width="5" /><line x1="0" y="0" x2="50" y2="0" stroke="black" stroke-width="6" />',
  },
];

let i = 0;
pattern_list.forEach(p => {
  p['ind'] = i++;
});

export const patterns = pattern_list;
export const solid_fill = pattern_list[0];
